import { Api } from "../config/request";

export default {
  getFleetCoachList(body) {
    return Api.post(`/catalyst/fleet-coach/list`, body);
  },
  getFleetCoachDetails(id) {
    return Api.get(`/catalyst/fleet-coach/${id}`);
  },
  saveUpdateFleetCoach(body) {
    return Api.post(`/catalyst/fleet-coach/upsert`, body);
  },
  updateFleetCoachDocument(id, body) {
    return Api.put(`/catalyst/fleet-coach/${id}/documents`, body);
  },
};
